import themeColors from 'assets/theme/colors'

const classes = {
  mainBox: {
    background: themeColors.kroemtech.navy,
    paddingTop: '3.5rem'
  },
  grid: {
    display: 'grid',
    columnGap: '2rem',
    rowGap: '2.5rem',
    paddingBottom: '3rem'
  },
  columnTitle: {
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: '#fff',
    marginBottom: '1.25rem'
  },
  // Shared by plain text and links, so a column of addresses lines up with a
  // column of links without either needing its own spacing rules.
  body: {
    fontSize: '0.875rem',
    lineHeight: 1.7,
    color: 'rgba(255, 255, 255, 0.72)'
  },
  link: {
    display: 'block',
    fontSize: '0.875rem',
    lineHeight: 1.7,
    color: 'rgba(255, 255, 255, 0.72)',
    textDecoration: 'none',
    transition: 'color 0.15s ease',
    '&:hover': {
      color: '#fff'
    }
  },
  linkList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.7rem'
  },
  block: {
    marginTop: '1.25rem'
  },
  socialBox: {
    display: 'flex',
    gap: '0.6rem',
    marginTop: '1.75rem'
  },
  lowerBox: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '3.75rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.15)'
  },
  copyright: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.55)'
  }
}

export default classes
